import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import TransportForm from "../../../../components/forms/transportForm/index";
import { FailedNotify, SuccessNotify } from "../../../../constants/tostify";
import { useSelector } from "react-redux";
import Loader from "../../../../components/Loader";
import { publishImage } from "../../../../helpers/imageupload";
import { useDropzone } from "react-dropzone";
import { useCreateShopMutation } from "../../../../features/shop/shopApiSlice";
const CreateTransport = () => {
  const navigate = useNavigate();
  const { name } = useSelector((state) => state.user);
  const [displayimg, setDisplayimg] = useState();
  const [isUploading, setIsUploading] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);
  const [shopCategory, setShopCategory] = useState();
  const [isloading, setIsloading] = useState(false);
  const onDrop = async (acceptedFiles) => {
    try {
      setIsUploading(true);
      setUploadProgress(0);

      const abc = await publishImage(acceptedFiles, (percent) => {
        setUploadProgress(percent);
      });
      setCreateShop((createShop) => ({
        ...createShop,
        image: abc
      }));

      setDisplayimg(abc);

    } catch (error) {
      FailedNotify("Failed! Try Again");
    }
    finally {
      setIsUploading(false);
      setUploadProgress(0);
    }
  }

  const { getRootProps, getInputProps } = useDropzone({
    accept: "image/*",
    onDrop,
  });



  const [selectshop, setSelectshop] = useState({
    shopCategory: ""
  });
  const Shopdatas = (e) => {
    setSelectshop((prevState) => ({
      ...prevState,
      [e.target.name]: e.target.value.split("."),
    }));
  };

  const categoryName = selectshop?.shopCategory[1];
  const categoryid = selectshop?.shopCategory[0];

  localStorage.setItem('mycategory', categoryName);

  const [createShop, setCreateShop] = useState({
    userid: name._id,
    shopname: "",
    shopaddress: "",
    shoplicense: "",
    contact: "",
    image: [""],
    marketPlace: "",
    shopCategory: "",
    businessType: "transportShop",
    description: "",
    status: true,
  });



  const [createShopMutation] = useCreateShopMutation();

  const PostShopData = async (e) => {
    setIsloading(true);
    e.preventDefault();
    
    let submitData = { ...createShop };
    if (!submitData.shopCategory || submitData.shopCategory === "Select Category") {
      delete submitData.shopCategory;
    } else if (submitData.shopCategory.includes(".")) {
      submitData.shopCategory = submitData.shopCategory.split(".")[0];
    }

    try {
      const response = await createShopMutation(submitData).unwrap();
      if (response?.success) {
        setIsloading(false);
        setTimeout(() => {
          SuccessNotify("Transport-Form Created Successfully");
          navigate(`/transport-bussiness-profile/${response?.data?._id}`);
        }, 1000);
      }
    } catch (error) {
      setIsloading(false);
      const backendMessage = error?.data?.message || error?.message || "Failed To Create Shop";
      FailedNotify(backendMessage);
    }
  };
  if (isloading) {
    return (
      <div>
        <Loader heightsetting="screenHeight" />
      </div>
    );
  }
  return (
    <div>
      <TransportForm
        title="Fill to Create Transport Profile"
        inputtitle="Transport Shop"
        CreateHandler={PostShopData}
        setCreateShop={setCreateShop}
        createShop={createShop}
        butn="Create"
        backurl="/transport-integrate"
        shopCategory={shopCategory}
        getInputProps={getInputProps}
        getRootProps={getRootProps}
        displayimg={displayimg}
        setDisplayimg={setDisplayimg}
        Shopdatas={Shopdatas}
        isUploading={isUploading}
        uploadProgress={uploadProgress}
      />
    </div>
  );
};
export default CreateTransport;
